module.exports = __webpack_public_path__ + "img/mu.70f4fe19.svg";